import React from 'react';
import SvgIcon from './SvgIcon';

const EventInformation = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M4.5 9a.5.5 0 010-1H14a.5.5 0 010 1H4.5zM4.5 12a.5.5 0 010-1h6a.5.5 0 010 1h-6zM4.5 6a.5.5 0 010-1h7a.5.5 0 010 1h-7zM4.5 15a.5.5 0 010-1h4a.5.5 0 01.5.5c0 .276-4.5.5-4.5.5zM4.5 18a.5.5 0 010-1h4a.5.5 0 010 1h-4z"
            fill="currentColor"
        />
        <path
            d="M1.5 24C.673 24 0 23.327 0 22.5v-21C0 .673.673 0 1.5 0h13.293c.401 0 .777.156 1.061.439l3.707 3.707c.283.284.439.661.439 1.061V8.5a.5.5 0 01-1 0V5.207a.501.501 0 00-.146-.354l-3.707-3.707A.505.505 0 0014.793 1H1.5a.5.5 0 00-.5.5v21a.5.5 0 00.5.5h9a.5.5 0 010 1h-9z"
            fill="currentColor"
        />
        <path
            d="M17.5 24a6.508 6.508 0 01-6.5-6.5c0-3.584 2.916-6.5 6.5-6.5s6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-12a5.506 5.506 0 00-5.5 5.5c0 3.033 2.467 5.5 5.5 5.5s5.5-2.467 5.5-5.5-2.467-5.5-5.5-5.5z"
            fill="currentColor"
        />
        <path
            d="M16.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zM16 21a.5.5 0 010-1h1v-3h-1a.5.5 0 010-1h1a1 1 0 011 1v3h1a.5.5 0 010 1h-3z"
            fill="currentColor"
        />
    </SvgIcon>
);

EventInformation.displayName = 'EventInformationIcon';

export default EventInformation;
